export default __webpack_public_path__ + "static/media/ebox.9547c8dd.png";